import React, { useState } from 'react';
import { TextField, Button, Typography, Box, Alert, Grid } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { login } from '../../hooks/security/auth';
import { Link } from 'react-router-dom';

function Formulary({ onLoginSuccess, setData }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      setError('Credenciales inválidas');
      return;
    }

    try {
      setLoading(true);

      const userData = await login(username.trim(), password);

      setData(userData);

      onLoginSuccess();

    } catch {
      setError('Usuario o contraseña incorrectos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleLogin} sx={{ marginLeft: '30px', width: '400px', p: '35px' }}>
      <Typography variant="h5" sx={{ color: 'white', mb: 2 }}>
        Acceso
      </Typography>

      {error && <Alert severity="error">{error}</Alert>}

      <TextField
        placeholder="Teléfono"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        fullWidth
        margin="normal"
        sx={{ backgroundColor: 'white', borderRadius: 1, marginTop: "0px" }}
      />

      <TextField
        placeholder="Clave"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
        margin="normal"
        sx={{ backgroundColor: 'white', borderRadius: 1 }}
      />

      <Grid container spacing={2} alignItems="center" sx={{ marginTop: "1px" }}>
        <Grid item xs={4}>
          <Button type="submit" variant="contained" color="error" fullWidth disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </Grid>
        <Grid item xs={8}>
          <Link to="/forgot-password" style={{ color: 'white', textDecoration: 'none' }}>
            He olvidado mi clave <ArrowForwardIosIcon sx={{ fontSize: '1rem' }} />
          </Link>
        </Grid>
      </Grid>

      <Typography sx={{ mt: 2 }}>
        <Link to="/register" style={{ color: 'white', textDecoration: 'none' }}>
          ¿No registrado? Regístrate aquí
        </Link>
      </Typography>
    </Box>
  );
}

export default Formulary;
